import { render, staticRenderFns } from "./TachyonParticle.vue?vue&type=template&id=374b7fbb&scoped=true"
import script from "./TachyonParticle.vue?vue&type=script&lang=js"
export * from "./TachyonParticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b7fbb",
  null
  
)

export default component.exports